import moment from "moment";
import RideitPassenger, { IRideitPassenger } from "./RideitPassenger";

export enum RideitPassengerTokenStatus {
  Active = 'Active',
  Expired = 'Expired',
  Revoked = 'Revoked'
}

export interface IRideitPassengerToken {
  id: number;
  token: string;
  expiresAt?: moment.Moment | Date | string | null;
  passenger: IRideitPassenger;
  claimerId: string;
  claimerName: string;
  claimerUserName: string;
  claimedAt?: moment.Moment | Date | string | null;
  createdAt: moment.Moment | Date | string;
  createdBy: string;
  tripsFetchedAt?: moment.Moment | Date | string | null;
  revokedAt?: moment.Moment | Date | string | null;
  revokedBy: string;
}

export class RideitPassengerToken implements IRideitPassengerToken {
  id: number;
  token: string;
  expiresAt?: moment.Moment | Date | string | null;
  passenger: RideitPassenger;
  claimerId: string;
  claimerName: string;
  claimerUserName: string;
  claimedAt?: moment.Moment | Date | string | null;
  createdAt: moment.Moment | Date | string;
  createdBy: string;
  tripsFetchedAt?: moment.Moment | Date | string | null;
  revokedAt?: moment.Moment | Date | string | null;
  revokedBy: string;


  constructor(data?: IRideitPassengerToken | null) {
    this.id = data?.id ?? 0;
    this.token = data?.token ?? '';
    this.expiresAt = data?.expiresAt ?? null;
    this.passenger = new RideitPassenger(data?.passenger ?? null);
    this.claimerId = data?.claimerId ?? '';
    this.claimerName = data?.claimerName ?? '';
    this.claimerUserName = data?.claimerUserName ?? '';
    this.claimedAt = data?.claimedAt ?? null;
    this.createdAt = data?.createdAt ?? '';
    this.createdBy = data?.createdBy ?? '';
    this.tripsFetchedAt = data?.tripsFetchedAt ?? null;
    this.revokedAt = data?.revokedAt ?? null;
    this.revokedBy = data?.revokedBy ?? '';
  }

  get status() {
    if (this.revokedBy) {
      return RideitPassengerTokenStatus.Revoked;
    }

    if (!this.claimedAt && this.expiresAt) {
      const now = moment();
      const expiresAt = moment(this.expiresAt);
      return expiresAt.isAfter(now) ? RideitPassengerTokenStatus.Active : RideitPassengerTokenStatus.Expired;
    }

    return RideitPassengerTokenStatus.Active;
  }
}

export default RideitPassengerToken;
